<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="robot"/>
          {{ $t('title') }}
        </h1>
      </div>
    </div>
    <list></list>
  </main>
</template>

<script>
import List from './ClientChatbotList.vue';

export default {
  name: "ClientChatbot",
  components: {List},
  i18n: {
    messages: {
      en: {
        title: 'AI agent order',
      },
      vi: {
        title: 'Đơn hàng nhân viên AI',
      }
    }
  }
}
</script>